import { render, staticRenderFns } from "./GrnIndex.vue?vue&type=template&id=3cd91904&"
import script from "./GrnIndex.vue?vue&type=script&lang=js&"
export * from "./GrnIndex.vue?vue&type=script&lang=js&"
import style0 from "./GrnIndex.vue?vue&type=style&index=0&id=3cd91904&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports